import { GoalProgressChartData } from '@occc/graphql';

export type ParsedChartData = {
  totalToDate: number;
  dailyNew: number;
  date: Date;
  goalForDate: number;
  progressForDate: number;
};

export enum XAxisTickIntervals {
  Day = 0,
  Week = 6,
  TwoWeeks = 13,
}

export type MonthlyGoalProgress = {
  target: number;
  current: number;
};

export type RetailerNetworkPerformanceChartData = {
  newMembersGoalProgress: MonthlyGoalProgress;
  newMembersChartData: GoalProgressChartData[];
  loyaltyTransactionsGoalProgress: MonthlyGoalProgress;
  loyaltyTransactionsChartData: GoalProgressChartData[];
};

export type ChartName = 'newMembers' | 'loyaltyTransactions';
